import i18next from "i18next";
import moment from "moment/min/moment-with-locales";

import { languageConfig } from "./languageConfig";

i18next.init(languageConfig);

// Set the moment locale imperatively (not only from an event handler) so it
// is already configured when the very first render happens — SSR renders and
// hydration must produce identical date strings; relying on the
// 'languageChanged' event races with hydration on the client.
moment.updateLocale("cs", {
    calendar: {
        sameElse: "l",
    },
});
moment.locale(languageConfig.lng ?? i18next.language);

i18next.on("languageChanged", function (lng) {
    moment.locale(lng);

    // Store the selected language in localStorage (browser only)
    if (typeof window !== "undefined") {
        localStorage.setItem("i18nextLng", lng);
    }
});

export { i18next };
